import { Inject } from 'inversify-props'
import { VendaServiceAdapter } from './adapter'
import { Page, ResumoDaVenda, Venda, VendaComReferencias } from '@/models'
import { AxiosRequestConfig } from 'axios'

export class FindVendaUseCase {
	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Venda>> =>
		await this.vendaService.find(params, config)

	list = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ResumoDaVenda>> =>
		await this.vendaService.listVendas(params, config)

	get = async  (id: string): Promise<Venda> =>
		await this.vendaService.get(id)

	getVendaComReferencias = async  (id: string): Promise<VendaComReferencias> =>
		await this.vendaService.getVendaComReferencias(id)

}
